import axios from 'axios';
import { PARAMS } from '../../const';
import { API_SECTION_USER_ALL_NOTES, API_SECTION_USER_HIGHLIGHTS, API_SECTION_USER_NOTE_HIGHLIGHTS } from './apiConst';
import { manageArrayResponse } from './apiResponse';
import { getLogger } from '../logger';

const debug = getLogger('services:api:annotationsApi');

export async function getSectionNotes(classId, userId) {
  if (!classId || !userId) {
    debug.error('[getSectionNotes] classId: "%s" | userId: "%s"', classId, userId);
    return [];
  }
  const pathname = API_SECTION_USER_ALL_NOTES.replace(PARAMS.SECTION, classId).replace(PARAMS.USER, userId);
  const response = await manageArrayResponse(axios.get(pathname));
  return response.data;
}

export async function getSectionHighlights(classId, userId) {
  if (!classId || !userId) {
    debug.error('[getSectionHighlights] classId: "%s" | userId: "%s"', classId, userId);
    return [];
  }
  const pathname = API_SECTION_USER_HIGHLIGHTS.replace(PARAMS.SECTION, classId).replace(PARAMS.USER, userId);
  const response = await manageArrayResponse(axios.get(pathname));
  return response.data;
}

export async function getSectionNoteHighlights(classId, userId) {
  if (!classId || !userId) {
    debug.error('[getSectionNoteHighlights] classId: "%s" | userId: "%s"', classId, userId);
    return [];
  }
  const pathname = API_SECTION_USER_NOTE_HIGHLIGHTS.replace(PARAMS.SECTION, classId).replace(PARAMS.USER, userId);
  const response = await manageArrayResponse(axios.get(pathname));
  return response.data;
}
